import styled from 'styled-components';

export const StyledText = styled.p`
margin: 0rem 1rem;
font-size: 1rem;
font-weight: bold;
`;


